import LMSDispatcher from "../LMSDispatcher";

import { IApi, Api } from '../../utilities/Api';
import { ApiRequest } from '../../utilities/ApiRequest';
import * as ACTIONCONTANTS from './ActionConstants';
import CalculatedPropertyViewData, { ICalculatedPropertyViewData } from "../../models/property/CalculatedPropertyViewData";
import IReading, { ReadingData } from "../../models/property/ReadingData";
import PartitionsViewData, { IPartitionsViewData } from "../../models/property/PartitionsViewData";
import i18next from "i18next";



class CalculatedPropertyActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT);
    }


    async getSelected(id: string[], testplanId: string) {
        try {
            const request = new ApiRequest("/calculatedproperty/details?ids=" + id.join('&ids=') +"&testplanId="+ testplanId, "", null, i18next.t("Calculated Properties Details not found."));
            const result = await this.api.get(request);
            const payload = this.convertResponseListData(result.data);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.CALCULATED_PROPERTY_GET_ALL_DETAILS,
                payload: {
                    data: payload
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async getPartitions(calculatedId: string, propertyId: string, testplanId: string) {
        try {
            const request = new ApiRequest("/calculatedproperty/partitionDetails?id=" + calculatedId + "&propertyId="
             + propertyId + "&testplanId=" + testplanId, "", null, i18next.t("Partitions not found."));
            const result = await this.api.get(request);
            const payload = this.convertResponsePartitionsData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.GET_ALL_PARTITIONS,
                payload: {
                    data: payload
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async getAllValues() {
        try {
            const request = new ApiRequest("/calculatedproperty/readingvalues", "", null, i18next.t("Unable to fetch reading values."));
            const result = await this.api.get(request);
            const payload = this.convertResponseSourceListData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.CALCULATED_PROPERTY_GET_ALL_READING_VALUES,
                payload: {
                    propertyDataList: payload
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async getAllSource() {
        try {
            const request = new ApiRequest("/calculatedproperty/readingsource", "", null, i18next.t("Unable to fetch reading source."));
            const result = await this.api.get(request);
            const payload = this.convertResponseSourceListData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.CALCULATED_PROPERTY_GET_ALL_READING_SOURCE,
                payload: {
                    propertyDataList: payload
                }
            });
        } catch (error) {
            throw error;
        }
    }


    private convertResponseData(data: any): ICalculatedPropertyViewData {
        return new CalculatedPropertyViewData(data.id, data.name, data.formula, data.variables);
    }

    private convertResponseListData(data: any): ICalculatedPropertyViewData[] {
        const result: ICalculatedPropertyViewData[] = [];

        data.forEach((element: any) => {
            result.push(this.convertResponseData(element));
        });
        return result;
    }

    private convertResponsePartitionsData(data: IPartitionsViewData): IPartitionsViewData {
        return new PartitionsViewData(data.instrumentId, data.instrumentName, data.variable, data.partitions);
    }

    private convertResponseSourceData(data: any): IReading {
        return new ReadingData(data.id, data.name);
    }

    private convertResponseSourceListData(data: any): IReading[] {
        const result: IReading[] = [];

        data.forEach((element: any) => {
            result.push(this.convertResponseSourceData(element));
        });
        return result;
    }

}

const calculatedPropertyActions = new CalculatedPropertyActions();
export default calculatedPropertyActions;